export default __webpack_public_path__ + "static/media/marcospaz.ac3822ec.jpg";